import { Injectable } from '@angular/core';
import { IAnagraficaApparato } from '@common/interfaces/anagraficaApparato';
import { Topics } from '@common/interfaces/topics';
import ColorHash from 'color-hash';
import { ActionService } from '../action/action.service';
import { CrudService } from '../crudService';
import { BaseEntityStoreStrategy } from '../updateStoreStrategies';
import { AnagraficaApparatoQuery } from './anagraficaApparato.query';
import { AnagraficaApparatoStore } from './anagraficaApparato.store';

@Injectable({
  providedIn: 'root'
})
export class AnagraficaApparatoService extends CrudService<IAnagraficaApparato, AnagraficaApparatoStore, AnagraficaApparatoQuery> {
  colorHash = new ColorHash();

  constructor(
    protected store: AnagraficaApparatoStore,
    public query: AnagraficaApparatoQuery,
    protected actionService: ActionService,
    protected updateStrategy: BaseEntityStoreStrategy,
  ) {
    super(Topics.ANAGRAFICA_APPARATO, store, query, actionService, updateStrategy);
  }
}
